module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading && (!_vm.workerCount || _vm.isLastUpdateMoreThan15MinAgo)) ? _c('div', {
    staticClass: "result-no-workers notification"
  }, [_c('p', [_vm._v("You are currently offline 😞 If you just started mining please be patient, it can take up to 10 minutes for your workers to show up!")])]) : _vm._e(), (_vm.workerCount) ? _c('div', {
    staticClass: "box-summary box fs-16 fw-400"
  }, [_c('div', [(_vm.isLastUpdateMoreThan15MinAgo) ? _c('span', [_vm._v("Your last activity was having ")]) : _c('span', [_vm._v("You currently have ")]), (_vm.workerCount === 1) ? _c('b', [_vm._v(_vm._s(_vm.workerCount) + " worker online ")]) : _c('b', [_vm._v(_vm._s(_vm.workerCount) + " workers online ")]), _c('span', [_vm._v("connected to ")]), (_vm.algorithmCount === 1) ? _c('b', [_vm._v(_vm._s(_vm.algorithmCount) + " algorithm ")]) : _c('b', [_vm._v(_vm._s(_vm.algorithmCount) + " algorithms ")]), _c('span', [_vm._v("with a total hash rate of ")]), _vm._l((_vm.hashrates), function(item, index) {
    return [_c('b', [_vm._v(_vm._s(item.value) + " (" + _vm._s(_vm._f("capitalize")(item.name)) + ")")]), (index < _vm.hashrates.length - 2) ? _c('span', [_vm._v(", ")]) : (index === _vm.hashrates.length - 2) ? _c('span', [_vm._v(" and ")]) : _vm._e()]
  })], 2), _c('div', {
    staticClass: "fs-11 mt-10"
  }, [_c('span', {
    class: {
      'animate-long': _vm.updated
    }
  }, [_vm._v("Last updated " + _vm._s(_vm.timeAgo))])])]) : _vm._e(), _c('ListEvents', {
    ref: "listRef",
    attrs: {
      "uuid": _vm.uuid,
      "isLoadingParent": _vm.isLoading
    },
    on: {
      "goToTab": _vm.goToTab
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9df02c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_live.vue
// module id = 372
// module chunks = 1